export const NUMBER_FORMAT_ERROR = 'Enter the full document number';
export const NO_ERROR = '';

export type FieldError = typeof NUMBER_FORMAT_ERROR | typeof NO_ERROR;
